module.exports = __webpack_public_path__ + "img/plus-icon-white.925c3afe.svg";